import * as React from 'react';
import { cn } from '@hqo/react-hooks';

interface PaperProps extends React.HTMLAttributes<HTMLDivElement> {
  elevation?: number;
}

const Paper = React.forwardRef<HTMLDivElement, PaperProps>(
  ({ className, elevation = 1, children }: PaperProps, ref) => {
    const shadowClass = {
      0: 'shadow-none',
      1: 'shadow-sm',
      2: 'shadow',
      3: 'shadow-md',
      4: 'shadow-lg',
      5: 'shadow-xl',
    }[elevation] || 'shadow-sm';

    return (
      <div
        ref={ref}
        className={cn(
          'bg-background border rounded-lg',
          shadowClass,
          className,
        )}
      >
        {children}
      </div>
    );
  },
);

Paper.displayName = 'Paper';

export { Paper };
